<nz-select *ngIf="dataset[row][colData.Name] !== undefined" nzShowSearch nzAllowClear
    [disabled]="GetDisabledValue()" nzPlaceHolder="Select a {{colData.Title}}"
    [(ngModel)]="dataset[row][colData.Name]" (ngModelChange)="valueChanged($event);">
    <ng-container *ngFor="let option of options">
        <nz-option [nzValue]="option.Code.toString()" [nzLabel]="option.Name"></nz-option>
    </ng-container>
</nz-select>
